import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localTime'
})
export class LocalTimePipe implements PipeTransform {
  transform(value: number): any {
    const d = new Date(value);
    return d.toLocaleTimeString();
  }
}
